/**
 * Accordion
 * @class
 * @constructor
 * @public
 */
class Accordion {
  /**
   * Constructor
   * @param {string} name The container to handle
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    this.accordions = document.getElementsByClassName('accordion--js');

    // Engage engines
    if (this.accordions) {
      this.init();
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init() {
    const that = this;

    Array.prototype.forEach.call(that.accordions, function(accordion) {
      // Expand button
      const expandButton = accordion.getElementsByClassName('button-expand--js')[0];
      if (expandButton) {
        expandButton.addEventListener('click', function(event) {
          event.preventDefault();
          accordion.classList.add('accordion--is-expanded');
          this.parentNode.classList.add('hidden');
        });
      }
    });

    return this;
  }
};

module.exports = Accordion;
